// extracted by mini-css-extract-plugin
module.exports = {"header":"styles-module__header___3F6ye","tabContent":"styles-module__tabContent___3LWJT"};